import { computed } from 'vue'
import { VALID_BUTTON_TYPES } from '../constants/split-button-constants.js'

/**
 * Core logic composable for MsSplitButton
 * Handles state computations and validations
 */
export function useSplitButton(props) {
  // Validation computed
  const isValidType = computed(() => {
    return VALID_BUTTON_TYPES.includes(props.type)
  })

  // State computations
  const isDisabled = computed(() => {
    return Boolean(props.disabled)
  })

  // Content checks
  const hasText = computed(() => {
    return Boolean(props.text)
  })

  const hasLeftIcon = computed(() => {
    return Boolean(props.leftIcon)
  })

  const hasMenuItems = computed(() => {
    return Array.isArray(props.menuItems) && props.menuItems.length > 0
  })

  // Border logic
  const shouldShowBorder = computed(() => {
    return Boolean(props.hasBorder)
  })

  const shouldShowParentBorder = computed(() => {
    return Boolean(props.hasBorderParent)
  })

  // Menu configuration
  const shouldShowMenu = computed(() => {
    return Boolean(props.hasShowMenu)
  })

  const hasCustomPosition = computed(() => {
    return Boolean(props.customPositionMenu)
  })

  const hasCustomWidth = computed(() => {
    return props.customWidth > 0
  })

  // Tooltip
  const hasTooltip = computed(() => {
    return Boolean(props.tooltipText)
  })

  return {
    // Validation
    isValidType,
    
    // State
    isDisabled,
    
    // Content
    hasText,
    hasLeftIcon,
    hasMenuItems,
    
    // Border
    shouldShowBorder,
    shouldShowParentBorder,
    
    // Menu
    shouldShowMenu,
    hasCustomPosition,
    hasCustomWidth,
    
    // Tooltip
    hasTooltip
  }
}
